"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStudentsList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_bootstrap_1 = require("react-bootstrap");
var accessibility_helper_1 = require("../../../../api/helpers/accessibility.helper");
var DpStudentsList_styled_1 = require("./DpStudentsList.styled");
var DpCheckbox_1 = require("../../Checkbox/DpCheckbox");
var DpStudentsList = function (_a) {
    var students = _a.students, allStudentsSelected = _a.allStudentsSelected, selectHandler = _a.selectHandler;
    // ------------------------- State
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var _b = (0, react_1.useState)(allStudentsSelected), allChecked = _b[0], setAllChecked = _b[1];
    var _c = (0, react_1.useState)(false), allIndeterminate = _c[0], setAllIndeterminate = _c[1];
    (0, react_1.useEffect)(function () {
        setAllChecked(allStudentsSelected);
    }, [allStudentsSelected]);
    // ------------------------- Methods
    // ------------------------- Actions
    var selectAll = function (checked) {
        selectHandler(checked, students.map(function (student) { return (__assign(__assign({}, student), { selected: checked })); }));
        setAllChecked(!allChecked);
        setAllIndeterminate(false);
    };
    var selectStudent = function (studentSelected) { return function (checked) {
        var studentsUpdated = students.map(function (studentComposed) {
            return studentComposed.student.id === studentSelected.id
                ? __assign(__assign({}, studentComposed), { selected: checked }) : studentComposed;
        });
        var allStudentsChecked = studentsUpdated.every(function (student) { return student.selected; });
        setAllChecked(allStudentsChecked);
        var allStudentsIndeterminate = studentsUpdated.some(function (student) { return student.selected; });
        setAllIndeterminate(allStudentsChecked === false && allStudentsIndeterminate);
        selectHandler(allStudentsChecked, studentsUpdated);
    }; };
    var handleEnter = function (e) {
        var _a;
        (_a = e.target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.click();
    };
    // ------------------------- Render
    return ((0, jsx_runtime_1.jsx)(DpStudentsList_styled_1.StyledStudentsList, { role: "tabpanel", children: students.length > 0 ? ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.ListGroup, { as: "ul", children: [(0, jsx_runtime_1.jsxs)(react_bootstrap_1.ListGroup.Item, { as: "li", className: "all-row", tabIndex: 0, onKeyDown: (0, accessibility_helper_1.handleButtonPress)(handleEnter), "aria-label": t('reopenModal.labelAllStudents', {
                        totalStudents: students.length,
                    }), children: [(0, jsx_runtime_1.jsx)(DpCheckbox_1.DpCheckbox, { changeHandler: selectAll, checked: allChecked, indeterminate: allIndeterminate && !allChecked, ariaLabelledbyId: "all-students" }), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", id: "all-students", children: t('reopenModal.allStudents') })] }, "all"), students.map(function (_a) {
                    var student = _a.student, selected = _a.selected;
                    return ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.ListGroup.Item, { as: "li", className: "student", tabIndex: 0, onKeyDown: (0, accessibility_helper_1.handleButtonPress)(handleEnter), "aria-label": t('reopenModal.labelStudent', {
                            name: student.fullName,
                        }), children: [(0, jsx_runtime_1.jsx)(DpCheckbox_1.DpCheckbox, { changeHandler: selectStudent(student), checked: selected, ariaLabelledbyId: "student-".concat(student.id) }), (0, jsx_runtime_1.jsxs)("span", { id: "student-".concat(student.id), className: "student-name", children: [student.lastName, ", ", student.firstName] })] }, student.id));
                })] })) : null }));
};
exports.DpStudentsList = DpStudentsList;
exports.default = exports.DpStudentsList;
